// @ts-nocheck
/* eslint-disable */
import Header from "~/ui/header";
import createHeaderButton from "~/ui/headerbutton";
import { CHEVRON_LEFT_16, SHARE_FILLED_16 } from "@sznds/icons";
import { createOnboarding } from "~/ui/onboarding";
import { getItem, setItem } from "~/es6/localstorage";
import MyReviews from "./myreviews";
import SuggestedReviews from "./suggestedreviews";
import { node } from "~/util/dom";
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { PAGE_MY, PAGE_SUGGEST } from "./constants";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import { createTab, createTabs } from "~/ui/tabs";
import { CONFIG } from "~/config";

function buildTabs() {
	const tabs = createTabs();
	const myButton = createTab(_("mymap.reviews.tabMy"));
	const suggestButton = createTab(_("mymap.reviews.tabSuggested"));

	myButton.setAttribute("data-log-section", "reviews");
	myButton.addEventListener("click", () => {
		Mapy.getComponent("reviews").state = { activePage: PAGE_MY };
		Mapy.getComponent("history").save();
	});

	suggestButton.setAttribute("data-log-section", "reviews");
	suggestButton.addEventListener("click", () => {
		Mapy.getComponent("reviews").state = { activePage: PAGE_SUGGEST };
		Mapy.getComponent("history").save();
	});

	tabs.classList.add("myreviews__topbar__ui-tabs");
	tabs.appendChild(myButton);
	tabs.appendChild(suggestButton);

	return {
		tabs,
		myButton,
		suggestButton,
	};
}

export default class Reviews {
	constructor() {
		this._activePage = PAGE_MY;
		this._container = node("div", { className: "reviews-main-cont" });
		this._isActive = false;

		const { tabs, myButton, suggestButton } = buildTabs();

		this._pages = {
			[PAGE_MY]: {
				subpage: new MyReviews({ tabs }),
				tabButton: myButton,
			},
			[PAGE_SUGGEST]: {
				subpage: new SuggestedReviews({ tabs }),
				tabButton: suggestButton,
			},
		};

		this._activePage = PAGE_MY;
		this._pages[this._activePage].tabButton.classList.add("active");

		this._buildHeader();
		this._buildOnboarding();

		this._container.appendChild(this._pages[this._activePage].subpage.node);

		const watchUser = watch(store.getState, "user", watchCurrentUser);

		this._storeUnsubscribe = store.subscribe(watchUser(newUser => {
			this._header.avatar = newUser.user.avatar;
			this._header.premium = newUser.user.premium ? "mapy" : "none";
		}));
	}

	destroy() {
		this._container.remove();
		this._storeUnsubscribe();
	}

	activate(actState) {
		if (this._isActive) {
			return this;
		}

		this._isActive = true;
		this._setState(actState);

		if (!getItem("onboardingReviews")) {
			setItem("onboardingReviews", 1);
		}

		Mapy.getComponent("logger").log("view", { text: "reviews" });
		this._pages[this._activePage].subpage.activate();

		return this;
	}

	deactivate() {
		if (!this._isActive) {
			return this;
		}

		this._isActive = false;
		this._pages[this._activePage].subpage.deactivate();

		return this;
	}

	get isActive() {
		return this._isActive;
	}

	get container() {
		return this._container;
	}

	set state(state) {
		const { activePage } = state;

		if (activePage && activePage !== this._activePage) {
			if (this._isActive) {
				this._pages[this._activePage].subpage.deactivate();
			}
			this._pages[this._activePage].subpage.node.remove();
			this._pages[this._activePage].tabButton.classList.remove("active");
			if (this._isActive) {
				this._pages[activePage].subpage.activate();
			}
			this._container.appendChild(this._pages[activePage].subpage.node);
			this._pages[activePage].tabButton.classList.add("active");
			this._activePage = activePage;
		}
	}

	get state() {
		return {
			cat: this._activePage === PAGE_MY ? "reviews" : "review-suggestions",
		};
	}

	_setState(actState = {}) {
		if ("activePage" in actState) {
			this._activePage = actState.activePage;
		}

		const { user } = store.getState().user;

		if (user.state !== "green") {
			Mapy.getComponent("mymaps").activeComponent();
		}
	}

	_buildHeader() {
		const { user } = store.getState().user;

		this._header = new Header({
			title: _("mymap.switcher.reviews"),
			avatar: user.avatar,
			premium: user.premium ? "mapy" : "none",
		});
		this._container.appendChild(this._header.node);

		// tlacitko zpet
		const back = createHeaderButton({
			icon: CHEVRON_LEFT_16,
			innerHTML: _("mymap.stateswitch"),
		});

		back.addEventListener("click", function backClick() {
			Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("dashboard"));
			Mapy.getComponent("history").save();
			Mapy.getComponent("reviews").state = { activePage: PAGE_MY };
		});
		back.setAttribute("data-log-text", "backToDashboard");
		this._header.leftButtons.appendChild(back);

		// sdileci tlacitko
		const shareButton = createHeaderButton({
			icon: SHARE_FILLED_16,
			innerHTML: _("mymap.contextMenu.share"),
		});

		this._header.rightButtons.appendChild(shareButton);
		shareButton.addEventListener("click", () => {
			const { user } = store.getState().user;

			let sharePopup = new MyMapsShare({
				type: "reviews",
				url: `${location.protocol}//${CONFIG.BASE_URL}/?up=${user.userPublicId}&upc=reviews`,
				noFrame: true,
				text: node("p", {}, _("mymap.dashboard.shareText")),
			}, function shareCallback() {
				sharePopup.destroy();
				sharePopup = null;
			});

			sharePopup.open();
		});
	}

	_buildOnboarding() {
		if (!getItem("onboardingReviews")) {
			this._onboarding = createOnboarding({
				onClose: () => {
					this._onboarding.remove();
				},
				innerHTML: _("mymap.reviews.onboarding"),
			});
			this._container.appendChild(this._onboarding);
		}
	}
}
